export {
    Video,
    type VideoProps,
    type AltSourceProps,
    type VidTypes
} from "./video";
export { Video as default } from "./video";
